import { Stack } from "@mui/material";
import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useToggle } from "react-use";
import * as yup from "yup";
import { Body1, EntradaForm, H6 } from "../../../components";
import { cashbackNew } from "./reducers/cashback-actions";

const STR = {
  title: "Novo Cashback",
  subtitle:
    "Digite o número do CV para criar um novo cashback. O sistema vai buscar a venda e criar automaticamente o cashback para o cliente",
  labelCV: "Número do CV",
  placeholderCV: "Digite o número do CV",
  errorCV: "Digite o número do CV no formato XXXXXXX-XXXX",
};

const KEYS = {
  cv: "cv",
};

function CashbackNew() {
  const dispatch = useDispatch();
  const [wait, setWait] = useToggle();
  const schema = [
    {
      type: "text",
      name: KEYS.cv,
      label: STR.labelCV,
      placeholder: STR.placeholderCV,
      mask: [
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        /[a-fA-F0-9]/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ],
      required: true,
    },
  ];
  const schemaMessageError = {
    [KEYS.cv]: STR.errorCV,
  };
  const schemaValidator = yup.object().shape({
    [KEYS.cv]: yup
      .string()
      .matches(/^[a-fA-F0-9]{7}-\d{4}$/)
      .required(),
  });

  const onSubmit = useCallback(
    (val) => {
      dispatch(
        cashbackNew(
          {
            [KEYS.cv]: val[KEYS.cv],
          },
          setWait
        )
      );
    },
    [dispatch, setWait]
  );

  return (
    <Stack>
      <H6>{STR.title}</H6>
      <Body1>{STR.subtitle}</Body1>
      <EntradaForm
        schema={schema}
        schemaMessageError={schemaMessageError}
        schemaValidator={schemaValidator}
        wait={wait}
        onSubmit={onSubmit}
      />
    </Stack>
  );
}

export default CashbackNew;
